var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { consume } from '@lit/context';
import { LitElement, html, nothing } from 'lit';
import { authenticationContext } from '../../../Authentication/context';
import { registerCustomElement } from '../../../utils/registerCustomElement';
import { styles } from './styles';
import { state } from 'lit/decorators.js';
import '../../../Button';
import '../../../Icon';
let ModalUpgradeGoogle = class ModalUpgradeGoogle extends LitElement {
    constructor() {
        super(...arguments);
        // State for determining what step they're on
        this.step = 'unsubscribe';
        // State to disable while redirecting
        this.chosenProduct = false;
        // Close/dismiss
        this._close = () => {
            this.dispatchEvent(new CustomEvent('close'));
        };
        // Downgrade to Free
        this._continueToGooglePlay = () => {
            const url = 'https://play.google.com/store/account/subscriptions';
            window.open(url, '_blank');
            this.step = 'resubscribe';
        };
        // Contact Support
        this._contactSupport = () => {
            const url = 'https://support.vsco.co';
            window.open(url, '_blank');
        };
        // Upgrade to Pro
        this._continueToStripe = () => {
            var _a, _b;
            // Get Pro product from Stripe
            const proYearly = (_b = (_a = this.authentication) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.find(p => p.active &&
                p.name.toLowerCase().includes('pro') &&
                p.default_price.recurring.interval === 'year');
            if (!proYearly)
                return;
            // Send up event
            this.dispatchEvent(new CustomEvent('chooseProduct', {
                detail: {
                    product: proYearly,
                },
            }));
            // Show loading state
            this.chosenProduct = true;
        };
        // Button logic
        this._getButtons = () => {
            // Need to unsub
            if (this.step === 'unsubscribe') {
                return html `
        <grain-button
          @click=${() => this._contactSupport()}
          size="lg"
          variant="secondary"
          ?fullwidth=${true}
          ?disabled=${this.chosenProduct}
          >Contact Support</grain-button
        >
        <grain-button
          @click=${() => this._continueToGooglePlay()}
          size="lg"
          variant="primary"
          ?fullwidth=${true}
          ?disabled=${this.chosenProduct}
          >Cancel Current Plan</grain-button
        >
      `;
            }
            // Otherwise, ready to upgrade
            return html `
      <grain-button
        @click=${() => this._continueToStripe()}
        size="lg"
        ?fullwidth=${true}
        ?disabled=${this.chosenProduct}
        >Upgrade to Pro</grain-button
      >
    `;
        };
    }
    render() {
        return html `<div class="google">
      <h2 class="title">Upgrade with Android membership</h2>
      <p class="description">
        It looks like your Plus membership was made through Google Play, which
        doesn&apos;t support a Pro membership. To upgrade to Pro, please do the
        following:
      </p>
      <div class="steps">
        <div class="step ${this.step === 'unsubscribe' ? 'on' : ''}">
          <div class="number">
            ${this.step === 'unsubscribe'
            ? html `<span class="counter"></span>`
            : nothing}
            ${this.step === 'resubscribe'
            ? html `<span class="check">
                  <grain-icon name="checkmark" />
                </span>`
            : nothing}
          </div>
          <div class="text">Cancel your current membership on Google Play.</div>
        </div>
        <div class="separator"></div>
        <div class="step ${this.step === 'resubscribe' ? 'on' : ''}">
          <div class="number">
            <span class="counter"></span>
          </div>
          <div class="text">Start a new membership through our site.</div>
        </div>
      </div>
      <div class="buttons">${this._getButtons()}</div>
    </div>`;
    }
};
ModalUpgradeGoogle.styles = styles;
__decorate([
    consume({ context: authenticationContext, subscribe: true })
], ModalUpgradeGoogle.prototype, "authentication", void 0);
__decorate([
    state()
], ModalUpgradeGoogle.prototype, "step", void 0);
__decorate([
    state()
], ModalUpgradeGoogle.prototype, "chosenProduct", void 0);
ModalUpgradeGoogle = __decorate([
    registerCustomElement('grain-modal-upgrade-google')
], ModalUpgradeGoogle);
export { ModalUpgradeGoogle };
